
































































































































































import Vue from 'vue';
import CallLogWithDurationResourceViewModel from '../../../../services/v1/viewModel/resource/CallLogWithDurationResourceViewModel';

export default Vue.extend({
  auth: true,
  role: ['admin', 'hostadmin'],
  layout: 'layout-hostadmin',
  data: () => ({
    callLogDetail: {} as CallLogWithDurationResourceViewModel,
    isRequestBodyValid: true,
    isResponseBodyValid: true,
  }),
  computed: {
    callLogId() {
      const idParam = this.$router.currentRoute.params.id;
      return Number.parseInt(idParam, 10);
    },
  },
  async mounted() {
    await this.populateData();
  },
  methods: {
    async populateData() {
      const responseCallLog = await this.$service.api.core.callLogs.getCallLogById(this.callLogId);
      // TODO: Parse JSON and set isRequestBodyTruncated flag
      this.callLogDetail = responseCallLog;
      this.callLogDetail.requestBody = await this.loadRequestBody();
      this.callLogDetail.responseBody = await this.loadResponseBody();
    },
    async loadRequestBody() {
      let callLogRequestBody = this.callLogDetail.requestBody ?? 'undefined';
      try {
        callLogRequestBody = JSON.stringify(JSON.parse(callLogRequestBody), undefined, 2);
        return callLogRequestBody;
      } catch {
        this.isRequestBodyValid = false;
        return callLogRequestBody;
      }
    },
    async loadResponseBody() {
      let callLogResponseBody = this.callLogDetail.responseBody ?? 'undefined';
      try {
        callLogResponseBody = JSON.stringify(JSON.parse(callLogResponseBody), undefined, 2);
        return callLogResponseBody;
      } catch {
        this.isResponseBodyValid = false;
        return callLogResponseBody;
      }
    },

  },
});
